import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerMatrix, getRevenueExport } from "redux/actions/UserReport";
import { getCustomer } from "redux/actions/UserCustomer";
import { getServiceCity } from "redux/actions/UserServiceCity";
import { dateFormate } from "utils/utils";
import { filterRevenueData } from "pages/rideTrack/RideTrackData";
import CustomerReportTab from "./CustomerReportTab";
import customerCount from "assets/images/customerCount.svg";

function Customer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [value, setValue] = useState("Ride");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateFrom, setDateFrom] = useState(
    dateFormate(new Date(), "MM/DD/YYYY")
  );
  const [dateTo, setDateTo] = useState(dateFormate(new Date(), "MM/DD/YYYY"));
  const [status, setStatus] = useState("");

  const tableData = useSelector(
    (state) => state?.userCustomer?.userCustomer?.data
  );
  const loader = useSelector((state) => state?.userCustomer?.loading);
  const customerMatrix =
    useSelector(
      (state) => state?.userCustomerMatrix?.userCustomerMatrix?.data
    ) || {};
  const isLoadingCustomerMatrix = useSelector(
    (state) => state?.userCustomerMatrix.loading
  );
  const locationData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const Location = locationData;
  const [locId, setLocId] = useState("");

  let filterData = {
    id: "",
    page: page,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    pageSize: rowsPerPage,
    type: value,
    search: "",
    location: locId?.toString(),
  };

  const titleData = {
    barTitle: "Customer Split",
    doughnutTitle: "Total  No. of Customer",
  };

  const handleChange = (newValue) => {
    if (newValue == "Ride") {
      dispatch(getCustomer({ ...filterData, type: "Ride" }));
      dispatch(getCustomerMatrix({ type: "ride" }));
    } else {
      dispatch(getCustomer({ ...filterData, type: "Rental" }));
      dispatch(getCustomerMatrix({ type: "rental" }));
    }
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getCustomer({ ...filterData, type: "Ride" }));
    dispatch(getCustomerMatrix({ type: "ride" }));
    dispatch(getServiceCity());
  }, []);

  const handleChangePage = (newPage) => {
    setPage(newPage);
    dispatch(getCustomer({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getCustomer({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const onInputChange = (e, data) => {
    setLocId(data?.id);
    dispatch(getCustomer({ ...filterData, location: data?.id }));
    dispatch(getCustomerMatrix({ ...filterData, location: data?.id }));
  };

  const onClickTableVendor = (data) => {
    navigate("/rideTrack/details", {
      state: {
        id: data?.id,
        status: data?.status,
        customer: data?.customerName,
        driver: data?.driverName,
        value,
        tripId: data?.tripId,
      },
    });
  };

  const onSelectDateRange = (newValue) => {
    if (newValue === null) {
      setDateFrom("");
      setDateTo("");
      filterData = { ...filterData, dateFrom: "", dateTo: "" };
    } else {
      setDateFrom(dateFormate(newValue[0], "MM/DD/YYYY"));
      setDateTo(dateFormate(newValue[1], "MM/DD/YYYY"));
      filterData = {
        ...filterData,
        dateFrom: dateFormate(newValue[0], "MM/DD/YYYY"),
        dateTo: dateFormate(newValue[1], "MM/DD/YYYY"),
      };
    }
    dispatch(getCustomer(filterData));
    dispatch(getCustomerMatrix(filterData));
  };

  const onFilterChange = (val) => {
    setStatus(val);
    setPage(0);
    filterData = { ...filterData, status: val.toString(), page: 0 };
    dispatch(getCustomer(filterData));
    dispatch(getCustomerMatrix(filterData));
  };

  const onRestFilter = () => {
    setStatus("");
    filterData = { ...filterData, status: "" };
    dispatch(getCustomer(filterData));
    dispatch(getCustomerMatrix(filterData));
  };

  const onExport = () => {
    const exportFilter = {...filterData, export:true, tabName:'customer-export'}
    dispatch(getRevenueExport(exportFilter));
  }

  return (
    <>
      <CustomerReportTab
        loader={loader}
        filterData={filterRevenueData}
        handleChange={handleChange}
        value={value}
        titleData={titleData}
        rideTrackData={tableData}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        page={page}
        rowsPerPage={rowsPerPage}
        isLoadingRideAnalytic={isLoadingCustomerMatrix}
        rideAnalytic={customerMatrix}
        onClickTableVendor={onClickTableVendor}
        title={"Customer"}
        filterDisplay={true}
        isClickable={false}
        countSrc={customerCount}
        Location={Location}
        onInputChange={onInputChange}
        onSelectDateRange={onSelectDateRange}
        dateFrom={dateFrom}
        dateTo={dateTo}
        defaultStatus={status}
        tabName={"rideTrack"}
        onExport={onExport}
      />
    </>
  );
}

export default Customer;
